import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalComponent } from '../../../../../models/modal-component';
import { DefaultWelcomeContentComponent } from './default-content/default-welcome-content.component';
import { FeatureInformationComponent } from './feature-information/feature-information.component';

@Component({
    selector: 'app-welcome-modal',
    templateUrl: './welcome-modal.component.html',
    styleUrls: ['./welcome-modal.component.scss'],
    imports: [
        DefaultWelcomeContentComponent,
        FeatureInformationComponent
    ],
    standalone: true
})
export class WelcomeModalComponent extends ModalComponent implements OnInit, AfterViewInit {
    static COOKIE_KEY = 'showWelcomeScreen';
    static MODAL_ID = 'welcomeModal';

    showContent = false;

    applicationStateService = inject(ApplicationStateService);
    private cookieService = inject(CookieService);

    ngOnInit(): void {
        if (this.cookieService.check(WelcomeModalComponent.COOKIE_KEY)) {
            this.showContent = this.cookieService.get(WelcomeModalComponent.COOKIE_KEY) === '1';
        }
    }

    onChange(): void {
        const oneMonth = 31;
        this.showContent = !this.showContent;
        const value = this.showContent ? '1' : '0';
        this.cookieService.set(WelcomeModalComponent.COOKIE_KEY, value, oneMonth, '/', undefined, true, 'Strict');
    }

    ngAfterViewInit(): void {
        $(`#${this.getId()}`).on('hidden.bs.modal', () => {
            if (!this.showContent) {
                const oneMonth = 31;
                const value = '0';
                this.cookieService.set(WelcomeModalComponent.COOKIE_KEY, value, oneMonth, '/', undefined, false, 'Strict');
            }
        });
    }

    getId(): string {
        return WelcomeModalComponent.MODAL_ID;
    }

    displayFeatureModal(): boolean {
        return this.applicationStateService.bookConfig?.quickLinkPrefix?.startsWith('gm');
    }
}
